// @ts-nocheck
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../layout/Header";
import { PostApi } from "../../../ApiClient/PostApi";
import { getLoginStatus, setLoginStatus } from "../../../Utils/AuthCheck";
import { error_toaster, success_toaster } from "../../toaster/Toaster";
import { Loader2 } from "../../loader/Loader";
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";
import { useFormik } from "formik";
import * as Yup from "yup";

export default function Login() {
  const navigate = useNavigate();
  useEffect(() => {
    if (getLoginStatus() === "true") {
      navigate("/");
    }
  }, []);
  const [edit, setEdit] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  // const onChange = (e) => {
  //   setEdit({ ...edit, [e.target.name]: e.target.value });
  // };
  const initialValues = {
    email: "",
    password: "",
  };
  const loginSchema = Yup.object({
    email: Yup.string().email().required("Please enter your email"),
    password: Yup.string().min(6).required("Please enter your password"),
  });
  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues,
      validationSchema: loginSchema,
      onSubmit: async (values, action) => {
        let res = await PostApi("users/login", {
          email: values.email,
          password: values.password,
        });
        if (res.data.status === "1") {
          navigate("/");
          setLoading(false);
          setLoginStatus(true);
          localStorage.setItem("BearerToken", res.data.data.accessToken);
          localStorage.setItem("firstName", res.data.data.firstName);
          localStorage.setItem("lastName", res.data.data.lastName);
          localStorage.setItem("email", res.data.data.email);
          localStorage.setItem("userId", res.data.data.id);

          success_toaster(res.data.message);
        } else if (res.data.status === "2") {
          localStorage.setItem("email", res.data.data.email);
          navigate("/email_otp");
        } else {
          setLoading(false);
          error_toaster(res.data.message);
        }
      },
    });

  const inputStyle =
    "w-full text-sm font-normal border border-themeGray px-2 py-3 rounded bg-themeGray focus:bg-transparent";
  const errorStyle =
    "w-full bg-themeGray2 border-none font-normal sm:text-base text-sm rounded-lg";
  return (
    <>
      <Header />
      <section className="lg:h-[calc(100vh-80px)] flex items-center lg:my-0 my-10">
        {loading ? (
          <Loader2 />
        ) : (
          <div className="xl:w-2/6 lg:w-3/6 sm:w-3/5 w-10/12 mx-auto flex flex-col justify-center gap-y-8 mt-20">
            <div className="flex justify-center">
              <Link to="/">
                <img
                  src="images/logo2.webp"
                  alt="logo"
                  className="sm:w-48 w-40"
                />
              </Link>
            </div>
            <div className="flex justify-between items-center">
              <h3 className="font-bold sm:text-4xl text-3xl">Login</h3>
              {/* <button onClick={sendSocket}>Send Socket</button> */}
              <Link
                to="/register"
                className="text-themeBlue2 font-medium sm:text-xl text-xl hover:text-themeRed mx"
              >
                Create New Account
              </Link>
            </div>

            <form
              onSubmit={handleSubmit}
              className="w-full mx-auto flex flex-col justify-center gap-y-10 relative"
            >
              {loading ? (
                <Loader2 />
              ) : (
                <>
                  <h1 className="text-white font-bold sm:text-5xl text-4xl text-center">
                    Sign in
                  </h1>
                  <div className="flex flex-col gap-y-5">
                    <div
                      className={errors.email && touched.email && errorStyle}
                    >
                      <input
                        type="email"
                        name="email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        placeholder="Email"
                        className={inputStyle}
                        autoComplete="on"
                      />
                      {errors.email && touched.email && (
                        <div className="px-5 text-red-600 space-y-1 pb-1 bg-white">
                          <p>{errors.email}</p>
                        </div>
                      )}
                    </div>
                    <div
                      className={
                        errors.password && touched.password && errorStyle
                      }
                    >
                      <div className="relative">
                        <button
                          onClick={() => setVisible(!visible)}
                          type="button"
                          className="text-black text-opacity-40 absolute right-4 top-1/2 -translate-y-1/2"
                        >
                          {visible ? (
                            <AiOutlineEye size={28} />
                          ) : (
                            <AiOutlineEyeInvisible size={28} />
                          )}
                        </button>
                        <input
                          type={visible ? "text" : "password"}
                          name="password"
                          value={values.password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          placeholder="Password"
                          className={inputStyle}
                          autoComplete="on"
                        />
                      </div>
                      {errors.password && touched.password && (
                        <div className="px-5 text-red-600 space-y-1 pb-1 bg-white">
                          <p>{errors.password}</p>
                        </div>
                      )}
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="bg-themeBlue px-14 py-2 rounded border border-themeBlue text-white 
                                              hover:bg-transparent hover:text-themeBlue font-medium text-xl"
                  >
                    Sign in
                  </button>
                  <button
                    onClick={() => navigate("/forget_password")}
                    className="text-themeBlue font-normal text-base text-center"
                  >
                    Forgot your password?
                  </button>
                  {/* <Link
                      to={"/verify_email"}
                      className="text-themeBlue text-opacity-60 font-medium sm:text-xl text-lg text-center py-3 px-8 rounded-md w-full border border-white border-opacity-60 hover:bg-white hover:bg-opacity-60 hover:text-black"
                    >
                      Verify Email
                    </Link> */}
                </>
              )}
            </form>
          </div>
        )}
      </section>
    </>
  );
}
